import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import styles from './marketing.module.css';

interface RailProps {
  children: ReactNode;
  className?: string;
}

/**
 * The 1440px content rail with the design system's inset. This is the page
 * width primitive for marketing pages; do not reach for Tailwind `container`
 * or `max-w-*` for that job.
 */
export function Rail({ children, className }: RailProps): React.ReactElement {
  return <div className={clsx(styles.rail, className)}>{children}</div>;
}
